import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner/banner.component';
import { WhyPlatformComponent } from './why-platform/why-platform.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { SecureFlowComponent } from './secure-flow/secure-flow.component';
import { BenchmarkLibraryComponent } from './benchmark-library/benchmark-library.component';
import { AudienceComponent } from './audience/audience.component';
import { AboutTanuhComponent } from './about-tanuh/about-tanuh.component';
import { FaqComponent } from './faq/faq.component';
import { CtaBannerComponent } from './cta-banner/cta-banner.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [
    CommonModule,
    BannerComponent,
    WhyPlatformComponent,
    HowItWorksComponent,
    SecureFlowComponent,
    BenchmarkLibraryComponent,
    AudienceComponent,
    AboutTanuhComponent,
    FaqComponent,
    CtaBannerComponent,
    FooterComponent,
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent {}
